import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '../../commons/Avatar/Avatar'
import BoxRounded from '../../commons/BoxRounded/BoxRounded'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'

const DetailStoreInfo = ({
  logoImageUrl,
  nameFantasy,
  subsidiary,
  tabNumber
}) => {
  return (
    <BoxRounded>
      <Flex>
        <Avatar
          image={logoImageUrl}
          size="medium"
          title={nameFantasy}
          radius={25}
        />
        <Flex column justifyContent="space-around" style={{ marginLeft: 20 }}>
          <Text
            size="md"
            color="gray"
            variation="dark"
            extraBold
            margin="0 0 8px 0"
          >
            {nameFantasy}
          </Text>
          <Text color="gray" variation="dark" font="custom" size="xs">
            {subsidiary} - {tabNumber}
          </Text>
        </Flex>
      </Flex>
    </BoxRounded>
  )
}

DetailStoreInfo.defaultProps = {
  logoImageUrl: null
}

DetailStoreInfo.propTypes = {
  logoImageUrl: PropTypes.string,
  nameFantasy: PropTypes.string.isRequired,
  subsidiary: PropTypes.string.isRequired,
  tabNumber: PropTypes.string.isRequired
}

export default DetailStoreInfo
